import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import {
  BingMapsContextProvider
} from '@bingads-webui-campaign-react/smart-component-bing-maps';
import { useSiteConfig } from '@bingads-webui-campaign-react/smart-page-context';
import {
  getComponentById,
  getDataSourceByKeys,
  DATA_SOURCE_KEY_MAPPING,
} from '@bingads-webui-campaign-react/smart-component-util';

import { SmartContactView } from './smart-contact-view';
import { proxyReadContactComponentConfig, getGeolocationInfo } from './components/component-config-reader';

export const SmartContactConnector = ({ id, isEditMode }) => {
  const i18n = useContext(I18nContext);
  const { siteConfig } = useSiteConfig();
  const {
    showEmail,
    showPhone,
    showLocation,
    showHours,
    showMap,
  } = proxyReadContactComponentConfig(getComponentById(siteConfig, id));
  const [
    emailList,
    phoneNumber,
    locationInfo,
  ] = getDataSourceByKeys(siteConfig, [
    DATA_SOURCE_KEY_MAPPING.Emails,
    DATA_SOURCE_KEY_MAPPING.PhoneNumber,
    DATA_SOURCE_KEY_MAPPING.LocationInfo,
  ]);
  const geoLocationInfo = getGeolocationInfo(siteConfig);

  return (
    <BingMapsContextProvider>
      <SmartContactView
        i18n={i18n}
        id={id}
        showEmail={showEmail}
        emailList={emailList}
        phoneNumber={phoneNumber}
        showPhone={showPhone}
        showLocation={showLocation}
        locationInfo={locationInfo}
        geoLocationInfo={geoLocationInfo}
        showHours={showHours}
        isEditMode={isEditMode}
        showMap={showMap}
      />
    </BingMapsContextProvider>
  );
};

SmartContactConnector.propTypes = {
  id: PropTypes.string.isRequired,
  isEditMode: PropTypes.bool,
};

SmartContactConnector.defaultProps = {
  isEditMode: false,
};
